// extracted by mini-css-extract-plugin
export default {"switcher":"language-switcher_switcher__NVB9J"};